window._version = "1.759.0";
module.exports = window._version;
